// User model 
export default class Watchman{
    constructor(id, usr_id, fcl_id, from_date, thru_date){
        this.id = id
        this.usr_id = usr_id
        this.fcl_id = fcl_id
        this.from_date = from_date
        this.thru_date = thru_date
    }
}